import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {

    @Input() showAcceptDecline: boolean;

    constructor() { }

    ngOnInit() {
    }
}
